var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"power-btn",class:{ active: _vm.isActive },on:{"click":_vm.toggle}},[_c('svg',{staticClass:"icon",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 2v10M5.5 6.5a8 8 0 1 0 13 0","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }